/**
 * @param {string} code
 * @param {string} message
 */
function testForErrCode (code, message) {
  const regexpedCode = code.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
  const regexp = new RegExp(`^${regexpedCode}`)

  return regexp.test(message)
}

export default testForErrCode



// WEBPACK FOOTER //
// ./src/utils/test-for-err-code.js